document.addEventListener('DOMContentLoaded', () => {
  function calculateTotalMonthsNeeded(
    savingAmount: number,
    savedAmount: number,
    monthlySaving: number,
    interestRate: number,
  ): number {
    if (interestRate <= 0 || monthlySaving <= 0) {
      return -1; // Return -1 for invalid inputs
    }

    const remainingAmount = savingAmount - savedAmount;

    if (remainingAmount <= 0) {
      return 0; // If the goal is already achieved, return 0 months needed
    }

    const monthlyInterestRate = interestRate / 100 / 12; // Convert annual interest rate to monthly

    // Using the formula for the future value of an annuity with compound interest
    // FV = P * ((1 + r)^n - 1) / r
    // where FV is the future value, P is the periodic payment, r is the interest rate per period,
    // and n is the total number of periods
    const n = Math.log(1 + (remainingAmount * monthlyInterestRate) / monthlySaving) / Math.log(1 + monthlyInterestRate);

    // Round up to the next whole month
    const totalMonthsNeeded = Math.ceil(n);
    return totalMonthsNeeded;
  }

  const savingAmountInput = document.getElementById('saving-amount') as HTMLInputElement;
  const savedAmountInput = document.getElementById('saved-amount') as HTMLInputElement;
  const monthlySavingInput = document.getElementById('saving-per-month') as HTMLInputElement;
  const interestRateInput = document.getElementById('interest') as HTMLInputElement;
  const totalMonthsElement = document.querySelector('.savings__calc__result-card h2');

  savingAmountInput.addEventListener('input', updateResult);
  savedAmountInput.addEventListener('input', updateResult);
  monthlySavingInput.addEventListener('input', updateResult);
  interestRateInput.addEventListener('input', updateResult);

  function updateResult() {
    const savingAmount = parseFloat(savingAmountInput.value) || 0;
    const savedAmount = parseFloat(savedAmountInput.value) || 0;
    const monthlySaving = parseFloat(monthlySavingInput.value) || 0;
    const interestRate = parseFloat(interestRateInput.value) || 0;

    const totalMonthsNeeded = calculateTotalMonthsNeeded(savingAmount, savedAmount, monthlySaving, interestRate);

    if (totalMonthsElement) {
      if (totalMonthsNeeded === -1) {
        totalMonthsElement.textContent = '';
      } else {
        const years = Math.floor(totalMonthsNeeded / 12);
        const months = totalMonthsNeeded % 12;

        let resultString = '';
        if (years > 0) {
          resultString += years.toString() + (years === 1 ? ' year' : ' years');
          if (months > 0) {
            resultString += ' and ';
          }
        }
        if (months > 0) {
          resultString += months.toString() + (months === 1 ? ' month' : ' months');
        }

        totalMonthsElement.textContent = resultString;
      }
    }
  }
});
